import { HttpClient } from '@angular/common/http';
import { AppConstants } from '../../../app.constants';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, of } from 'rxjs';
import { FileAccessModel } from '../../models/other/fileAccess.model';

@Injectable()
export class HttpFileService {
  private fileServiceAdress = AppConstants.CARRIERDB_LOGO;

  constructor(private http: HttpClient, private sanitizer: DomSanitizer) {}

  /**
   * Creates a safe url from a blob object
   * @param {Blob} blob
   * @returns {SafeUrl}
   */
  private _getSafeURL(blob: Blob) {
    return this.sanitizer.bypassSecurityTrustUrl(
      window.URL.createObjectURL(blob)
    );
  }

  public getImageType(base64Data: string): string | null {
    const match = base64Data.match(/^data:image\/([a-zA-Z0-9+]+);base64,/);
    return match ? match[1] : null;
  }

  /**
   * Upload a supplier company logo to the file service
   * Deletes / overwrites existing files under this name
   * @param {File} file
   * @param {string?} logoLink
   * @returns {Observable<any>}
   */
  public uploadSupplierLogo(file: File, type: string, logoLink?: string): Observable<any> {
    var metadata = {
      access: {
        ownerCanRead: true,
        ownerCanWrite: true,
        groupCanRead: true,
        groupCanWrite: false,
        othersCanRead: true,
        othersCanWrite: false,
      } as FileAccessModel,
    };

    const form = new FormData();
    form.append('metadata', JSON.stringify(metadata));
    form.append('file', file, logoLink + "." + type);

    let url = this.fileServiceAdress + '/' + logoLink + "." + type;

    return this.http.put<any>(url, form, {});
  }

  /**
   * retrieves an image from the file service by its url
   * @param {string} logoLink
   * @returns {Observable<SafeUrl | null>}
   */
  public getImage(logoLink: string): Observable<SafeUrl | null> {
    const httpImageOptions = {
      responseType: 'blob' as 'json',
      observe: 'response' as 'response',
    };

    return this.http
      .get<Blob>(`${this.fileServiceAdress}/${logoLink}`, httpImageOptions)
      .pipe(
        map((blob) => {
          if (blob.body === null || blob.body.type === 'application/json') {
            return AppConstants.OCCON_LOGO_SOURCE as SafeUrl;
          }
          return this._getSafeURL(blob.body);
        }),
        catchError(() => {
          return of(AppConstants.OCCON_LOGO_SOURCE as SafeUrl);
        })
      );
  }
}
